<template>
  <div>
    <Multiselect
      v-model="valueModel"
      :class="['asd-multiselect']"
      :options="colors"
      :searchable="false"
      :allowEmpty="false"
      :disabled="visibility > 0"
      trackBy="name"
      label="name"
      selectLabel="Vyberte zmáčknutím enteru"
      selectGroupLabel="Vyberte skupinu zmáčknutím enteru"
      selectedLabel="Vybráno"
      deselectLabel="Odeberte zmáčknutím enteru"
      deselectGroupLabel="Odeberte skupinu zmáčknutím enteru"
      placeholder="Vyberte barvu"
    >
      <template slot="singleLabel" slot-scope="{ option }">
        <span class="color-square" :style="{'backgroundColor': option.code}"></span> {{ option.name }}
      </template>

      <template slot="option" slot-scope="{ option }">
        <span class="color-square--list" :style="{'backgroundColor': option.code}"></span> {{ option.name }}
      </template>
    </Multiselect>
  </div>
</template>

<script>
import _ from 'lodash'
import Multiselect from 'vue-multiselect'
import colors from 'ENUMS/colors'

export default {
    name: 'ColorInput',
    components: {
        Multiselect,
    },
    props: {
        id: {
            required: true,
            type: String,
        },
        value: {
            type: Object,
            default: _ => {return {}},
        },
        visibility: {
            type: Number,
            required: false,
            default: _ => 0,
        },
    },
    data: function() {
        return {
            colors,
            internalValue: undefined,
        }
    },
    computed: {
        valueModel: {
            get() {
                const value = _.get(this, 'value.value.value', this.internalValue)
                if (value === undefined) {
                    return _.head(this.colors)
                } else {
                    return _.find(this.colors, c => c.code === value)
                }
            },
            set(value) {
                if (this.visibility === 0) {
                    this.internalValue = value.code
                    this.$emit('input', {
                        'value': {
                            'value': value.code,
                        },
                    })
                }
            },
        },
    },
}
</script>
<style lang="scss" scoped>
.color-square {
    width: 20px;
    height: 20px;
    display: inline-block;
    border-radius: 3px;
    margin: 0;
    transform: translate(-2px,-2px);
}
.color-square--list {
    width: 20px;
    height: 20px;
    border-radius: 3px;
    display: inline-block;
    transform: translateY(3px);
}
</style>


